module.exports = __webpack_public_path__ + "img/118.dc71ed4f.png";